import { render, staticRenderFns } from "./JudgingShortcuts.vue?vue&type=template&id=489be2fc&scoped=true"
import script from "./JudgingShortcuts.vue?vue&type=script&lang=js"
export * from "./JudgingShortcuts.vue?vue&type=script&lang=js"
import style0 from "./JudgingShortcuts.vue?vue&type=style&index=0&id=489be2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489be2fc",
  null
  
)

export default component.exports